/* eslint-disable react/display-name */
/* eslint-disable camelcase */
import React from 'react';
import Highlight from 'react-scale/components/ui/highlight';
import LidarIframe from '../LidarIframe.tsx';

export const instruction = `Label all cars, pedestrians, and cyclists in each frame.`;

const responseCode = `{
  "response": {
    "annotations": {
      "url": "https://static.scale.com/scaleapi-lidar-output/example.json"
    }
  },
  "task_id": "5967d6b572633603819b188d",
  "task": { ... }
}`;

export const code = `client.createLidarAnnotationTask({
  instruction: '${instruction}',
  labels: ['car', 'pedestrian', 'cyclist'],
  meters_per_unit: 2.3,
  max_distance_meters: 30
}, (err, task) => {
    // do something with task
});`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = { component: LidarIframe };
